"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UN_LOCK = exports.SPLASH_SCREEN_HIDE_TOGGLE = exports.LOCK = exports.BLITZ_STATS_UPDATE = exports.BLITZ_START_ROUND = exports.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE = exports.BLITZ_SHOW_SPLASH = exports.BLITZ_SET_ROUNDS = exports.BLITZ_ROUND_STARTED = exports.BLITZ_ROUND_RESULT = exports.BLITZ_ROUND_DEDUCT = exports.BLITZ_RESET_COUNTERS = exports.BLITZ_PLAY_UNPAUSE = exports.BLITZ_PLAY_STOP_RESPONDED = exports.BLITZ_PLAY_STOP = exports.BLITZ_PLAY_START_RESPONDED = exports.BLITZ_PLAY_START = exports.BLITZ_PLAY_PAUSE = exports.BLITZ_PLAY_FEATURE = exports.BLITZ_PAYLINE_WIN = exports.BLITZ_MODE_ON = exports.BLITZ_MODE_OFF = exports.BLITZ_FLYINGWINS_ENABLE = exports.BLITZ_FLYINGWINS_DISABLE = exports.BLITZ_FEATURE_WON = exports.BLITZ_FEATURE_STOP_TOGGLE = exports.BLITZ_FEATURE_SKIP = exports.BLITZ_FEATURE_IGNORE = exports.BLITZ_FEATURE_COUNT = exports.BLITZ_FEATURE_ADD_WIN = exports.BLITZ_CLOSE_SPLASH = void 0;
var BLITZ_MODE_ON = exports.BLITZ_MODE_ON = "BLITZ_MODE_ON";
var BLITZ_MODE_OFF = exports.BLITZ_MODE_OFF = "BLITZ_MODE_OFF";
var BLITZ_PLAY_START = exports.BLITZ_PLAY_START = "BLITZ_PLAY_START";
var BLITZ_PLAY_START_RESPONDED = exports.BLITZ_PLAY_START_RESPONDED = "BLITZ_PLAY_START_RESPONDED";
var BLITZ_PLAY_STOP_RESPONDED = exports.BLITZ_PLAY_STOP_RESPONDED = "BLITZ_PLAY_STOP_RESPONDED";
var BLITZ_PLAY_STOP = exports.BLITZ_PLAY_STOP = "BLITZ_PLAY_STOP";
var BLITZ_PLAY_PAUSE = exports.BLITZ_PLAY_PAUSE = "BLITZ_PLAY_PAUSE";
var BLITZ_PLAY_UNPAUSE = exports.BLITZ_PLAY_UNPAUSE = "BLITZ_PLAY_UNPAUSE";
/* Play next round, ready to fire next */
var BLITZ_START_ROUND = exports.BLITZ_START_ROUND = "BLITZ_START_ROUND";

/* Round was actually played */
var BLITZ_ROUND_STARTED = exports.BLITZ_ROUND_STARTED = "BLITZ_ROUND_STARTED";

/* Set -1 on the round count, used when playing a bonus round in classic. */
var BLITZ_ROUND_DEDUCT = exports.BLITZ_ROUND_DEDUCT = "BLITZ_ROUND_DEDUCT";
var BLITZ_ROUND_RESULT = exports.BLITZ_ROUND_RESULT = "BLITZ_ROUND_RESULT";

/** blitz through feature, ie dont play classic */
var BLITZ_FEATURE_SKIP = exports.BLITZ_FEATURE_SKIP = "BLITZ_FEATURE_SKIP";
var BLITZ_FEATURE_WON = exports.BLITZ_FEATURE_WON = "BLITZ_FEATURE_WON";
// Used to increase win in nested features. example book o blitz where each expanding is a feature. but should not be counted  s feature in blitz.
var BLITZ_FEATURE_ADD_WIN = exports.BLITZ_FEATURE_ADD_WIN = "BLITZ_FEATURE_ADD_WIN";
var BLITZ_FEATURE_STOP_TOGGLE = exports.BLITZ_FEATURE_STOP_TOGGLE = "BLITZ_FEATURE_STOP_TOGGLE";
var SPLASH_SCREEN_HIDE_TOGGLE = exports.SPLASH_SCREEN_HIDE_TOGGLE = "SPLASH_SCREEN_HIDE_TOGGLE";
var BLITZ_SPLASH_SCREEN_HIDE_TOGGLE = exports.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE = "BLITZ_SPLASH_SCREEN_HIDE_TOGGLE";
var BLITZ_PAYLINE_WIN = exports.BLITZ_PAYLINE_WIN = "BLITZ_PAYLINE_WIN";
var BLITZ_SET_ROUNDS = exports.BLITZ_SET_ROUNDS = "BLITZ_SET_ROUNDS";
var BLITZ_SHOW_SPLASH = exports.BLITZ_SHOW_SPLASH = "BLITZ_SHOW_SPLASH";
var BLITZ_CLOSE_SPLASH = exports.BLITZ_CLOSE_SPLASH = "BLITZ_CLOSE_SPLASH";
var BLITZ_RESET_COUNTERS = exports.BLITZ_RESET_COUNTERS = "BLITZ_RESET_COUNTERS";

/**
 * When a feature is hit and we should play it in classic mode. sent by blitz feature handler in each game
 */
var BLITZ_PLAY_FEATURE = exports.BLITZ_PLAY_FEATURE = "BLITZ_PLAY_FEATURE";

/**
 * Count as feature, increase count on feature count.
 */
var BLITZ_FEATURE_COUNT = exports.BLITZ_FEATURE_COUNT = "BLITZ_FEATURE_COUNT";

/**
 * Ignored feature.
 */
var BLITZ_FEATURE_IGNORE = exports.BLITZ_FEATURE_IGNORE = "BLITZ_FEATURE_IGNORE";

/**
 * used to update stats when its NOT a blitz round.
 */
var BLITZ_STATS_UPDATE = exports.BLITZ_STATS_UPDATE = "BLITZ_STATS_UPDATE";
var BLITZ_FLYINGWINS_ENABLE = exports.BLITZ_FLYINGWINS_ENABLE = "BLITZ_FLYINGWINS_ENABLE";
var BLITZ_FLYINGWINS_DISABLE = exports.BLITZ_FLYINGWINS_DISABLE = "BLITZ_FLYINGWINS_DISABLE";
var LOCK = exports.LOCK = "LOCK";
var UN_LOCK = exports.UN_LOCK = "UN_LOCK";
//# sourceMappingURL=types.js.map